import React, { useCallback, useRef, useState } from 'react';
import { useLanguage } from '../../assets/js/LanguageContext';
import Loader from '../common/Loader';
import Modal from '../common/Modal';
import { downloadSurveyPdf } from '../../utils/surveyDownloads';

const useSurveyPdf = () => {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const busyRef = useRef(false);

  const downloadPdf = useCallback(async (survey) => {
    if (!survey || busyRef.current) return;
    busyRef.current = true;
    setError(null);
    setLoading(true);
    try {
      await downloadSurveyPdf(survey);
    } catch (err) {
      console.error('Error al generar el PDF:', err);
      setError({ survey, unavailable: err.status === 503 });
    } finally {
      busyRef.current = false;
      setLoading(false);
    }
  }, []);

  const pdfUi = (
    <>
      {loading && <Loader overlay caption={t('sd_pdf_loading_hint')} />}
      <Modal
        open={Boolean(error)}
        onOpenChange={(open) => { if (!open) setError(null); }}
        variant="warning"
        title={t('sd_pdf_error_title')}
        description={error?.unavailable ? t('sd_pdf_error_unavailable') : t('sd_pdf_error_generic')}
        cancelText={error?.unavailable ? undefined : t('sd_pdf_close')}
        confirmText={error?.unavailable ? t('sd_pdf_ok') : t('sd_retry')}
        onConfirm={() => {
          const retry = error && !error.unavailable ? error.survey : null;
          setError(null);
          if (retry) downloadPdf(retry);
        }}
      />
    </>
  );

  return { downloadPdf, pdfLoading: loading, pdfUi };
};

export default useSurveyPdf;
